import { render } from "./wfm-loader.vue?vue&type=template&id=b80ddbc4"
import script from "./wfm-loader.vue?vue&type=script&lang=js"
export * from "./wfm-loader.vue?vue&type=script&lang=js"

import "./wfm-loader.vue?vue&type=style&index=0&id=b80ddbc4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__